/* eslint-disable no-underscore-dangle */
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';

/**
 * Agrupando elementos com arranjo simples
 * por Jonas Raoni Soares Silva
 * http://jsfromhell.com/array/simple-arrange [rev. #1]
 *
 * @param {array} a Array de elementos que serão reagrupados
 * @param {int} n Número de itens que deve ter por agrupamento
 * @param {*} m
 */
const simpleArrange = function (a, n, m) {
  let o = a;
  let j, l, k, p, f, r, q, x, i;
  if (n >= o.length) return [];
  for (
    j, l, k, p, f, r, q = k = 1, i = (l = o.length) + 1, j = l - n;
    --i;
    i <= j ? (q *= i) : (k *= i)
  );
  for (
    x = [new Array(n), new Array(n), new Array(n), new Array(n)],
      j = q = (k * q) / q,
      k = l + 1,
      i = -1;
    ++i < n;
    x[2][i] = i, x[1][i] = x[0][i] = j /= --k
  );
  for (r = new Array(q), p = -1; ++p < q; )
    for (
      r[p] = new Array(n), i = -1;
      ++i < n;
      !--x[1][i] && ((x[1][i] = x[0][i]), (x[2][i] = (x[2][i] + 1) % l)),
        r[p][i] = m ? x[3][i] : o[x[3][i]]
    )
      for (x[3][i] = x[2][i], f = 0; !f; f = !f)
        for (j = i; j; )
          if (x[3][--j] === x[2][i]) {
            x[3][i] = x[2][i] = (x[2][i] + ++f) % l;
            break;
          }
  return r;
};

/**
 * Pega as linhas que estão no array passado como argumento,
 * fazendo arranjo entre elas e verificando se fazem intercessão
 *
 * @param {array} lines Array de LineString (geoJSON format)
 */
const checkIntersection = (lines) => {
  let isSelfIntersecting = false;
  simpleArrange(lines, 2).forEach((arrange) => {
    // Cada `arrange` são dois segmentos de retas LineString
    let intersects = turf.lineIntersect(arrange[0], arrange[1]);
    let isVertice = false;
    intersects.features.forEach((feature) => {
      // Cada `feature` é um ponto
      // Verifico se a latitude e longitude conferem com algum dos pontos do LineString[0]. Comparar um só é suficiente
      arrange[0].geometry.coordinates.forEach((coordinate) => {
        if (
          coordinate[0] === feature.geometry.coordinates[0] &&
          coordinate[1] === feature.geometry.coordinates[1]
        ) {
          isVertice = true;
        }
      });
    });
    if (!isVertice && intersects.features.length > 0) {
      isSelfIntersecting = true;
    }
  });
  return isSelfIntersecting;
};

L.Polyline.include({
  selfIntersection: function () {
    // Para linhas criadas pelo geoman
    let latlng,
      isSelfIntersecting = false;
    if (this._renderer?._drawFirst?.layer?.pm?._layer._latlngs) {
      if (this._renderer?._drawFirst?.layer?.pm?._layer._latlngs[0]?.length) {
        // Para polígonos criados pelo geoman que na verdade são criados com linhas, não será muito útil pois utilizaremos o selfIntersection do próprio leafle
        latlng = this._renderer?._drawFirst?.layer?.pm?._layer._latlngs[0];
      } else {
        latlng = this._renderer?._drawFirst?.layer?.pm?._layer._latlngs;
      }
    } else {
      if (this._latlngs[0]) {
        // Para linhas criadas pelo leaflet geoJSON
        latlng = this._latlngs[0];
      } else {
        latlng = undefined;
      }
    }

    if (latlng) {
      // ! Talvez utilizar a abstração de números complexos seja mais prático depois https://brasilescola.uol.com.br/matematica/ponto-intersecao-entre-duas-retas.htm
      // Separando linhas em seguimentos de retas n-1, sendo n o número de pontos que temos.
      let lines = [];
      const n = latlng.length - 1;
      if (n > 0) {
        for (let i = 0; i < n; i++) {
          let line = turf.lineString([
            [latlng[i].lng, latlng[i].lat],
            [latlng[i + 1].lng, latlng[i + 1].lat],
          ]);
          lines.push(line);
        }
      }
      isSelfIntersecting = checkIntersection(lines);
    }
    return isSelfIntersecting;
  },
});

L.Polygon.include({
  selfIntersection: function () {
    let latlng,
      isSelfIntersecting = false;
    latlng =
      this._latlngs[0] ||
      this._renderer?._drawFirst?.layer?.pm?._layer._latlngs[0] ||
      undefined;
    if (latlng) {
      // As linhas aqui são diferente das polylines pq o último e o primeiro ponto da geometria também formam um segmento de reta. De forma que n vertices são n linhas
      let lines = [];
      const n = latlng.length;
      if (n > 0) {
        for (let i = 0; i < n; i++) {
          let line;
          if (i === n - 1) {
            // Se for o útimo ponto, deve ligar com o primeiro por se tratar de um polígono fechado
            line = turf.lineString([
              [latlng[i].lng, latlng[i].lat],
              [latlng[0].lng, latlng[0].lat],
            ]);
          } else {
            line = turf.lineString([
              [latlng[i].lng, latlng[i].lat],
              [latlng[i + 1].lng, latlng[i + 1].lat],
            ]);
          }
          lines.push(line);
        }
      }
      isSelfIntersecting = checkIntersection(lines);
    }
    return isSelfIntersecting;
  },
});
